module.exports = __webpack_public_path__ + "media/B2.4692f5c6.mp3";